import { KeyValueString } from '@app/interfaces';

export class SharedHelper {
	public static capitalize(name: string): string {
		if (typeof name !== 'string') {
			return '';
		}
		return name.charAt(0).toUpperCase() + name.slice(1);
	}

	public static downloadCSV(data: string, fileName: string): void {
		const blob = new Blob([data], { type: 'text/csv' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		a.click();
		window.URL.revokeObjectURL(url);
	}

	public static convertToCSV(data: any[], headers: KeyValueString[] = []): string {
		const header = SharedHelper.prepareCSVTableHeader(data, headers);
		const body = SharedHelper.prepareCSVTableBody(data, headers);

		return `${header}\r\n${body}`;
	}

	private static prepareCSVTableHeader(data: any[], headers: KeyValueString[] = []): string {
		let tableHeadRow = 'S.No,'; // string with all object's keys

		if (headers.length) {
			tableHeadRow = tableHeadRow + headers.map(({ key }) => key).join(',');
		} else {
			// If headers argument is empty > fill table header row with object key names
			const item = data[0];
			for (const key in item) {
				if (item.hasOwnProperty(key)) {
					tableHeadRow += key + ',';
				}
			}
		}

		return tableHeadRow;
	}

	private static prepareCSVTableBody(data: any[], headers: KeyValueString[]): string {
		const emptySymbol = '-';
		let tableBody = '';

		for (let i = 0; i < data.length; i++) {
			let line = i + 1 + '';
			const item = data[i];

			if (headers.length) {
				line += ',' + headers.map(({ value }) => item[value] || emptySymbol).join(',');
			} else {
				for (const key in item) {
					if (item.hasOwnProperty(key)) {
						const elem = typeof item[key] === 'string' ? item[key] : JSON.stringify(item[key]);
						line += ',' + (elem || emptySymbol);
					}
				}
			}

			tableBody += line + '\r\n';
		}

		return tableBody;
	}

	public static populateArrayFromEnum(enumeration: any, array: KeyValueString[]): void {
		Object.keys(enumeration).forEach((value) => {
			array.push({
				key: enumeration[value],
				value,
			});
		});
	}
}
